import tabbyLogo from "@/assets/logos/tabby-logo.png";
import tamaraLogo from "@/assets/logos/tamara-logo.png";
import { PROVIDER_PRESENTATION_MODE } from "@/lib/provider-presentation";

export default function PartnerLogos() {
  if (PROVIDER_PRESENTATION_MODE !== "partners") {
    return (
      <section className="py-10">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <p className="text-sm uppercase tracking-wide text-muted-foreground mb-3">
            Supported providers
          </p>
          <p className="text-base text-muted-foreground">
            Compare financing options from leading BNPL providers.
          </p>
        </div>
      </section>
    );
  }

  return (
    <section className="py-10">
      <div className="max-w-6xl mx-auto px-4">
        <p className="text-sm uppercase tracking-wide text-muted-foreground mb-8">
          Pay with your favourite provider
        </p>

        {/* Live integrations — large, prominent */}
        <div className="flex items-center justify-center gap-6 md:gap-10">
          <div className="flex items-center justify-center bg-[#3DF0A0] rounded-xl border border-[#3DF0A0] shadow-sm w-40 h-20 md:w-48 md:h-24 p-3">
            <img
              src={tabbyLogo}
              alt="Tabby"
              className="max-h-[75%] max-w-[80%] w-auto h-auto object-contain"
            />
          </div>
          <div className="flex items-center justify-center bg-[#1B2B3B] rounded-xl border border-[#1B2B3B] shadow-sm w-40 h-20 md:w-48 md:h-24">
            <span className="text-white font-sans font-bold text-2xl md:text-3xl lowercase tracking-tight">
              tamara
            </span>
          </div>
        </div>

        <p className="text-sm text-muted-foreground mt-6 text-center">
          Live integrations — book with Tabby or Tamara at checkout today
        </p>

        {/* Coming soon row — lighter style */}
        <p className="text-xs text-muted-foreground/60 mt-4 text-center">
          Cashew, Postpay, Spotii — coming soon
        </p>
      </div>
    </section>
  );
}
